import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Input, Typography } from 'antd';

import {
    useAnswerFeedbackMutation,
    useGetFeedbackByIdQuery,
} from '../service/adminFeedbackApi';
import { HeaderScenarios } from '../../../../communities/components/HeaderScenarios/HeaderScenarios';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';

type InfoBlockProps = {
    label: string;
    value: string;
};

export const FeedbackAnswerContainer = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { data: feedback } = useGetFeedbackByIdQuery(params.id);
    const [answerFeedback, { isSuccess, error, data, isError }] =
        useAnswerFeedbackMutation();
    const [message, setMessage] = useState('');

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, data, null, true);

    if (!feedback) return null;

    const InfoBlock = ({ label, value }: InfoBlockProps) => (
        <StyledBlock>
            <StyledTitle level={5}>{label}</StyledTitle>

            <div>
                <Typography.Text>{value}</Typography.Text>
            </div>
        </StyledBlock>
    );

    return (
        <Fragment>
            <StyledWrap>
                <HeaderScenarios withoutEdit inputValue={'Вопрос клиента'} />

                <StyledContent>
                    <InfoBlock label='ID обращения:' value={feedback.id} />
                    <InfoBlock label='Имя участника:' value={feedback.name} />
                    <InfoBlock
                        label='Статус обращения:'
                        value={feedback.status}
                    />
                    <InfoBlock label='Текст обращения:' value={feedback.text} />

                    {feedback.status !== 'Закрыт' && (
                        <StyledBlock>
                            <StyledTitle level={5}>Ваш ответ:</StyledTitle>
                            <div>
                                {feedback.status === 'Отвечен' && (
                                    <Typography.Text>
                                        {feedback.answer}
                                    </Typography.Text>
                                )}
                                {feedback.status === 'Новый' && (
                                    <Input.TextArea
                                        rows={4}
                                        value={message}
                                        onChange={event =>
                                            setMessage(event.target.value)
                                        }
                                    />
                                )}
                            </div>
                        </StyledBlock>
                    )}

                    {feedback.status === 'Новый' && (
                        <StyledActions>
                            <Button
                                type='primary'
                                onClick={() => {
                                    answerFeedback({
                                        id: params.id,
                                        message,
                                    });
                                }}
                            >
                                Ответить
                            </Button>
                            <Button type='default' onClick={() => navigate(-1)}>
                                Назад
                            </Button>
                        </StyledActions>
                    )}
                </StyledContent>
            </StyledWrap>
        </Fragment>
    );
};

const StyledTitle = styled(Typography.Title)<{ contentEditable?: boolean }>`
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 0 !important;
`;

const StyledActions = styled.div`
    display: flex;
    gap: 24px;
`;

const StyledBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const StyledWrap = styled.div`
    width: 686px;
`;
